var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3388 8.61766C19.4702 8.46746 19.5702 8.2925 19.633 8.10307C19.6958 7.91365 19.72 7.71357 19.7044 7.51463C19.6887 7.31569 19.6334 7.12189 19.5417 6.94464C19.45 6.76738 19.3238 6.61026 19.1705 6.4825C19.0172 6.35475 18.8399 6.25894 18.649 6.20072C18.4581 6.1425 18.2575 6.12305 18.059 6.1435C17.8605 6.16395 17.6681 6.2239 17.4931 6.31981C17.3181 6.41572 17.164 6.54566 17.04 6.70199L10.6046 14.423L7.27461 11.0916C6.99234 10.8189 6.61429 10.6681 6.22189 10.6715C5.82948 10.6749 5.45411 10.8323 5.17663 11.1098C4.89915 11.3873 4.74175 11.7626 4.73834 12.155C4.73493 12.5474 4.88578 12.9255 5.1584 13.2078L9.64823 17.6976C9.79528 17.8446 9.97134 17.9593 10.1652 18.0344C10.359 18.1096 10.5664 18.1435 10.7741 18.1341C10.9818 18.1246 11.1852 18.072 11.3714 17.9796C11.5577 17.8872 11.7226 17.757 11.8557 17.5973L19.3388 8.61766Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.ad877785bd97d1653768db189a3b4e99.svg";
export { ForwardRef as ReactComponent };